import {
  Zap,
  Flame,
  Droplet,
  Wifi,
  Tv,
  Trash2,
  Waves,
  MoreHorizontal,
} from 'lucide-react';

export const UTILITY_TYPES = [
  'electric',
  'gas',
  'water',
  'internet',
  'cable',
  'trash',
  'sewer',
  'other',
];

// Metering units are no longer defined here — the per-utility-type unit
// vocabulary is served from GET /api/v1/config/usage-units (api/config.py) so
// it's maintained in one place across clients. The bill form fetches it via
// ConfigService.getUsageUnits(); the local fallback mirror lives in
// ConfigService.DEFAULT_USAGE_UNITS.
export const UTILITY_META = {
  electric: { icon: Zap, color: 'text-yellow-500', label: 'Electric' },
  gas: { icon: Flame, color: 'text-orange-500', label: 'Gas' },
  water: { icon: Droplet, color: 'text-blue-500', label: 'Water' },
  internet: { icon: Wifi, color: 'text-purple-500', label: 'Internet' },
  cable: { icon: Tv, color: 'text-indigo-500', label: 'Cable' },
  trash: { icon: Trash2, color: 'text-gray-500', label: 'Trash' },
  sewer: { icon: Waves, color: 'text-teal-500', label: 'Sewer' },
  other: { icon: MoreHorizontal, color: 'text-gray-600', label: 'Other' },
};

export const getUtilityMeta = (type) => UTILITY_META[type] || UTILITY_META.other;

export const getUtilityDisplayName = (utility) => {
  if (!utility) return '';
  if (utility.name && utility.name.trim()) return utility.name;
  return getUtilityMeta(utility.type).label;
};
